import DateUtil from "../utils/DateUtil";

/**
 * mixin_区域转值
 */
export default {
    props: {},
    data() {
        return {}
    },
    created() {
    },
    methods: {
        /**
         * 时区转换
         * @param dateTimeString    来源时间串
         * @param fromTimeZone      来源时区(默认取系统时区)
         * @param toTimeZone        目标时区(默认取当前浏览器时区)
         * @returns {string}        目标时间串
         */
        parseTimeZoneDateTime(dateTimeString, fromTimeZone = (this.paramMapAll ||this.paramMap)['SYSTEM_TIME_ZONE'], toTimeZone) {
            if (dateTimeString && fromTimeZone) {
                return DateUtil.parseDateTime(dateTimeString, fromTimeZone, toTimeZone)
            }
            return DateUtil.readDate(dateTimeString);
        },
        parseTimeZoneDateTimeStr(dateTimeString, fromTimeZone, toTimeZone) {
            return DateUtil.format(this.parseTimeZoneDateTime(dateTimeString,fromTimeZone,toTimeZone));
        }
    }
}
